// Auth configuration from AWS Cognito deployment
// Environment variables are set during build time
// For local dev, these fall back to dev environment values

const isDev = process.env.REACT_APP_ENV === 'dev' || !process.env.REACT_APP_ENV;

const devConfig = {
  region: 'us-east-1',
  // From CrewCast-dev-Auth / CrewCast-dev-Backend stacks
  userPoolId: 'us-east-1_IjvHOURhR',
  userPoolClientId: '37upi7hbin16c645n53j8kcgo2',
  apiUrl: 'https://197npa106i.execute-api.us-east-1.amazonaws.com/dev',
};

const prodConfig = {
  region: 'us-east-1',
  // From CrewCast-prod-Auth / CrewCast-prod-Backend stacks
  userPoolId: 'us-east-1_ClmzYGvxc',
  userPoolClientId: '5jpci9k0om4hn29la9v8ntol36',
  apiUrl: 'https://mr19ou7go4.execute-api.us-east-1.amazonaws.com/prod',
};

export const authConfig = isDev ? devConfig : prodConfig;

